const searchJobsRules = {
  MANAGE: {
    SORT_BY: {
      options: [
        { text: 'Priority', value: 'priority' },
        { text: 'Dispatched Date', value: 'dateDispatched' },
        { text: 'Delivery ETA', value: 'dateDeliveryExpected' },
        { text: 'Pickup ETA', value: 'datePickupExpected' },
        { text: 'Recently Updated', value: 'lastModifiedDate' },
        { text: 'Pickup State', value: 'pickupLocation.addressRegion' },
        { text: 'Delivery State', value: 'deliveryLocation.addressRegion' },
        { text: 'Delivered Date', value: 'dateDeliveryActual' },
        { text: 'Pickup Zip Code', value: 'pickupLocation.addressPostalCode' },
        {
          text: 'Delivery Zip Code',
          value: 'deliveryLocation.addressPostalCode',
        },
      ],
    },
  },
  DEFAULT: {
    SORT_BY: {
      options: [
        { text: 'Recently Updated', value: 'lastModifiedDate' },
        { text: 'Pickup State', value: 'pickupLocation.addressRegion' },
        { text: 'Delivery State', value: 'deliveryLocation.addressRegion' },
        { text: 'Distance', value: 'distance' },
        { text: 'Inop Status', value: 'vehicle.isInoperable' },
        { text: 'Pickup Zip Code', value: 'pickupLocation.addressPostalCode' },
        {
          text: 'Delivery Zip Code',
          value: 'deliveryLocation.addressPostalCode',
        },
      ],
    },
  },
};
export default searchJobsRules;
